import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Redirect, Navigate, useNavigate, useLocation } from 'react-router-dom';
import './App.css'
import { store, setStore } from './app/store';

import Home from './pages/Website/Home/Home';
import About from './pages/Website/About/About';
import Infrastructure from './pages/Website/About/Infrastructure';
import Alumni from './pages/Website/Alumni/Alumni';
import Gallery from './pages/Website/Gallery/Gallery';
import Contact from './pages/Website/Contact/Contact';
import Login from './pages/Website/Login/Login';
import Profile from './pages/Website/Profile/Profile';
import Registration from './pages/Website/Registration/Registration';
import Logout from './pages/Logout/Logout';
import AlmaMater from "./pages/Website/AlmaMater/AlmaMater";
import TermsAndConditions from "./pages/Website/Policies/TermsAndConditions";
import PrivacyPolicy from "./pages/Website/Policies/PrivacyPolicy";
import RefundPolicy from "./pages/Website/Policies/RefundPolicy";
import CancellationPolicy from "./pages/Website/Policies/CancellationPolicy";
import Launching from './pages/Website/Launching/Launching';

// Wrapper component to get current route
function AppContent() {
  const location = useLocation();

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/infrastructure" element={<Infrastructure />} />
        <Route path="/alumni" element={<Alumni />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/almamater" element={<AlmaMater />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/login" element={<Login />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/cancellation-policy" element={<CancellationPolicy />} />
        <Route path="/launching" element={<Launching />} />
      </Routes>
    </>
  );
}

function App() {
  console.log("App Store Data: Testing....");
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;